<template>
  <div>
    <template v-if="serviceName === 'Regulatory FAQs'">
      <p class="title text-emergo-dark-blue fw-500" v-html="recordInfo.sub_category"></p>
      <p
        class="description word-break mb-0 text-secondary fw-400 font-16"
        v-html="recordInfo.question"
      ></p>
    </template>
    <template v-else-if="serviceName === 'Regulations & Guidance'">
      <p class="title text-emergo-dark-blue fw-500" v-html="recordInfo.document_name"></p>
      <p
        class="description word-break mb-0 text-secondary fw-400 font-16"
        v-html="recordInfo.description"
      ></p>
    </template>
    <template v-else-if="serviceName === 'Regulatory Watch'">
      <p class="title text-emergo-dark-blue fw-500" v-html="recordInfo.title"></p>
      <p
        class="description word-break mb-0 text-secondary fw-400 font-16"
        v-html="recordInfo.description"
      ></p>
    </template>
    <template v-else-if="serviceName === 'Regulatory Process Charts'">
      <p class="title text-emergo-dark-blue fw-500">{{ recordInfo.name }}</p>
    </template>
    <template v-else-if="serviceName === 'Government Fee Finder'">
      <p class="title text-emergo-dark-blue fw-500">
        {{ recordInfo.fee_name }}
      </p>
      <p class="description word-break mb-0 text-secondary fw-400 font-16">
        {{ recordInfo.classification }}
      </p>
    </template>
    <template v-else-if="serviceName === 'Guides and Templates'">
      <p class="title text-emergo-dark-blue fw-500">
        {{ recordInfo.resource_name }}
      </p>
      <p class="description word-break mb-0 text-secondary fw-400 font-16">
        {{ recordInfo.category_name }}
      </p>
    </template>
    <template v-else-if="serviceName === 'FDA Product Classification Lookup'">
      <p class="title text-emergo-dark-blue fw-500">
        {{ recordInfo.device_name }}
      </p>
      <p class="description word-break mb-0 text-secondary fw-400 font-16">
        {{ recordInfo.product_code }}
      </p>
    </template>
    <template v-else-if="serviceName === '510 (K) Review Time Calculator'">
      <p class="title text-emergo-dark-blue fw-500">
        {{ recordInfo.product_code }}
      </p>
      <p class="description word-break mb-0 text-secondary fw-400 font-16">
        {{ recordInfo.advisory_committee_description }}
      </p>
    </template>
    <template v-else-if="serviceName === 'Marketplace'">
      <p class="title text-emergo-dark-blue fw-500">{{ recordInfo.title }}</p>
      <p class="description word-break mb-0 text-secondary fw-400 font-16">
        {{ recordInfo.description }}
      </p>
    </template>
    <template v-else-if="serviceName === 'Regulatory Reports'">
      <p class="title text-emergo-dark-blue fw-500">
        {{ recordInfo.class_name }} - {{ recordInfo.artifact_name }}
      </p>
      <p class="description word-break mb-0 text-secondary fw-400 font-16">
        {{ recordInfo.mapped_file }}
      </p>
    </template>
    <template
      v-else-if="
        [
          'Agreements',
          'Product Tracker',
          'Records',
          'Notifications',
          'Dashboard',
          'Smart Builder',
          'Product Classification',
        ].includes(serviceName)
      "
    >
      <p class="title text-emergo-dark-blue fw-500">{{ recordInfo.data }}</p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    serviceName: {
      type: String,
      required: true,
    },
    recordInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.title {
  font-size: 22px;
  line-height: 26px;
}
.description {
  line-height: 19px;
}
</style>
